import { Injectable, PLATFORM_ID, Inject } from '@angular/core';
import {
  AuthenticationService,
  MarketplacePermission,
  IAccount,
} from '@libs/authentication/services';
import { untilDestroyed, UntilDestroy } from '@ngneat/until-destroy';
import { distinctUntilChanged, filter } from 'rxjs/operators';
import { isPlatformServer } from '@angular/common';

declare let window: any;
declare let document: any;

@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class DelightedService {
  appId: string;

  constructor(
    private auth: AuthenticationService,
    @Inject(PLATFORM_ID) private platformId,
  ) {
    if (isPlatformServer(platformId)) {
      return;
    }

    this.auth.permission$
      .pipe(
        untilDestroyed(this),
        filter((p: MarketplacePermission) => !!p?.emailAddress),
        distinctUntilChanged(),
      )
      .subscribe((profile: MarketplacePermission) => {
        this.initDelighted(profile);
      });
  }

  initDelighted(profile: MarketplacePermission): void {
    // dont reload script just because we got a change in the permission observable
    if (!window.delighted) {
      // had to unpack delighted script to something usable inside of typescript
      this.loadDelightedScript(
        window,
        document,
        [
          'survey',
          'reset',
          'config',
          'init',
          'set',
          'get',
          'event',
          'identify',
          'track',
          'page',
          'screen',
          'group',
          'alias',
        ],
        'vaxzZ186fsizsDo1',
        'delighted',
      );
    }

    const account: IAccount = this.auth.account$.getValue();

    const delay: any =
      window.location && window.location.hostname.match('snagajob.com')
        ? { createdAt: profile.createDate }
        : { initialDelay: 99999999 };

    const config = Object.assign({}, delay, {
      email: profile.emailAddress,
      name: profile.firstName + ' ' + profile.lastName,
      properties: {
        accountId: account.id,
        type: account.accountType,
      },
    });

    window.delighted.survey(config);
  }

  // refactored and beautified from delighted snippet
  loadDelightedScript(e, t, r, n, a): void {
    if (!e[a]) {
      for (var i: any = (e[a] = []), s = 0; s < r.length; s++) {
        const c = r[s];
        i[c] =
          i[c] ||
          (function (e) {
            return function () {
              const t = Array.prototype.slice.call(arguments);
              i.push([e, t]);
            };
          })(c);
      }
      i.SNIPPET_VERSION = '1.0.1';
      const o = t.createElement('script');
      (o.type = 'text/javascript'),
        (o.async = !0),
        (o.src =
          'https://d2yyd1h5u9mauk.cloudfront.net/integrations/web/v1/library/' +
          n +
          '/' +
          a +
          '.js');
      const p = t.getElementsByTagName('script')[0];
      p.parentNode.insertBefore(o, p);
    }
  }
}
